import { useEffect, useState } from 'react';
/**
 * A hook that returns true after the component has mounted.
 * Used to delay operations like data fetching until after the initial render.
 *
 * @returns {boolean} - True if the component has mounted, false otherwise
 */

export const usePageLoaded = () => {
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    setPageLoaded(true);
  }, []);

  return pageLoaded;
};

export default usePageLoaded;
